(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[941],{

/***/ 2405:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ Button; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6010);
/* harmony import */ var nextjs_button_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1900);
/* harmony import */ var _Button_module_sass__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5450);
/* harmony import */ var _Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Button_module_sass__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);





const Button = (param)=>{
    let { size =1 , fill ="empty" , fontWeight ="default" , fontSize ="default" , isBorder =false , isUpperCase =false , icon , ...otherProps } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(nextjs_button_base__WEBPACK_IMPORTED_MODULE_1__/* .ButtonBase */ .X, {
        ...otherProps,
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default().wrapper), (_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default())["is_size_".concat(size)], (_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default())["is_fill_".concat(fill)], (_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default())["is_fontWeight_".concat(fontWeight)], (_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default())["is_fontSize_".concat(fontSize)], isBorder && (_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default().is_border), isUpperCase && (_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default().is_upperCase)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ButtonContent, {
            icon: icon,
            children: otherProps.children
        })
    });
};
const ButtonContent = (param)=>{
    let { children , icon  } = param;
    const iconName = icon === null || icon === void 0 ? void 0 : icon.name;
    const iconPosition = icon === null || icon === void 0 ? void 0 : icon.position;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default().content), (_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default())["is_icon_".concat(iconPosition)]),
        children: [
            iconName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (_Button_module_sass__WEBPACK_IMPORTED_MODULE_4___default().icon),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_2__/* .Icon */ .J, {
                    name: iconName
                })
            }),
            children
        ]
    });
};


/***/ }),

/***/ 2537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6010);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Container_module_sass__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8539);
/* harmony import */ var _Container_module_sass__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_Container_module_sass__WEBPACK_IMPORTED_MODULE_3__);




function Container(props) {
    var _props_marginTop, _props_marginTop1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((_Container_module_sass__WEBPACK_IMPORTED_MODULE_3___default().wrapper), props.view && (_Container_module_sass__WEBPACK_IMPORTED_MODULE_3___default())[props.view]),
        style: {
            "--Container-margin-top": "".concat((_props_marginTop = props.marginTop) !== null && _props_marginTop !== void 0 ? _props_marginTop : 0, "px"),
            marginBottom: "".concat((_props_marginTop1 = props.marginTop) !== null && _props_marginTop1 !== void 0 ? _props_marginTop1 : 0, "px")
        },
        children: props.children
    });
}


/***/ }),

/***/ 7082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./app/components/Container.tsx
var Container = __webpack_require__(2537);
// EXTERNAL MODULE: ./app/components/Footer.module.sass
var Footer_module = __webpack_require__(6679);
var Footer_module_default = /*#__PURE__*/__webpack_require__.n(Footer_module);
// EXTERNAL MODULE: ./app/components/Logo.svg.tsx
var Logo_svg = __webpack_require__(924);
// EXTERNAL MODULE: ./app/components/PlanteeAppLink.module.sass
var PlanteeAppLink_module = __webpack_require__(6729);
var PlanteeAppLink_module_default = /*#__PURE__*/__webpack_require__.n(PlanteeAppLink_module);
;// CONCATENATED MODULE: ./app/components/PlanteeAppLink.tsx



function PlanteeAppLink() {
    return(// @TODO: link to appstores
    // eslint-disable-next-line jsx-a11y/anchor-is-valid
    /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
        href: "#",
        className: (PlanteeAppLink_module_default()).wrapper,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (PlanteeAppLink_module_default()).icon,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                    width: "25",
                    height: "25",
                    viewBox: "0 0 25 25",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M19.436 2.02637C21.09 2.02637 22.436 3.37237 22.436 5.02637V19.0264C22.436 20.6804 21.09 22.0264 19.436 22.0264H5.43604C3.78204 22.0264 2.43604 20.6804 2.43604 19.0264V5.02637C2.43604 3.37237 3.78204 2.02637 5.43604 2.02637H19.436ZM19.436 0.0263672H5.43604C2.67504 0.0263672 0.436035 2.26537 0.436035 5.02637V19.0264C0.436035 21.7874 2.67504 24.0264 5.43604 24.0264H19.436C22.198 24.0264 24.436 21.7874 24.436 19.0264V5.02637C24.436 2.26537 22.198 0.0263672 19.436 0.0263672ZM11.436 8.02637H10.436V6.02637H11.436V7.02637H13.436V8.02637H12.436V9.02637H11.436V8.02637ZM13.436 20.0264V19.0264H12.436V20.0264H13.436ZM12.436 5.02637V4.02637H10.436V5.02637H11.436V6.02637H12.436V5.02637ZM20.436 4.02637V10.0264H19.436V9.02637H15.436V4.02637H20.436ZM19.436 8.02637V5.02637H16.436V8.02637H19.436ZM5.43604 10.0264H4.43604V11.0264H6.43604V10.0264H5.43604ZM5.43604 13.0264H6.43604V14.0264H7.43604V11.0264H6.43604V12.0264H4.43604V14.0264H5.43604V13.0264ZM10.436 14.0264V16.0264H11.436V14.0264H10.436ZM14.436 4.02637H13.436V7.02637H14.436V4.02637ZM14.436 9.02637V8.02637H13.436V9.02637H14.436ZM17.436 7.02637H18.436V6.02637H17.436V7.02637ZM7.43604 6.02637H6.43604V7.02637H7.43604V6.02637ZM9.43604 4.02637V9.02637H4.43604V4.02637H9.43604ZM8.43604 5.02637H5.43604V8.02637H8.43604V5.02637ZM17.436 10.0264V11.0264H16.436V10.0264H14.436V11.0264H13.436V10.0264H10.436V9.02637H9.43604V10.0264H8.43604V11.0264H9.43604V13.0264H10.436V12.0264H11.436V14.0264H12.436V12.0264H15.436V13.0264H13.436V14.0264H15.436V15.0264H16.436V12.0264H17.436V13.0264H18.436V15.0264H19.436V14.0264H20.436V13.0264H19.436V12.0264H18.436V11.0264H19.436V10.0264H17.436ZM6.43604 18.0264H7.43604V17.0264H6.43604V18.0264ZM4.43604 15.0264H9.43604V20.0264H4.43604V15.0264ZM5.43604 19.0264H8.43604V16.0264H5.43604V19.0264ZM17.436 16.0264V15.0264H16.436V16.0264H17.436ZM17.436 17.0264H16.436V18.0264H15.436V17.0264H14.436V16.0264H15.436V15.0264H13.436V14.0264H12.436V16.0264H11.436V17.0264H10.436V20.0264H11.436V19.0264H12.436V18.0264H14.436V20.0264H15.436V19.0264H16.436V20.0264H18.436V19.0264H19.436V18.0264H17.436V17.0264ZM8.43604 14.0264H9.43604V13.0264H8.43604V14.0264ZM18.436 16.0264V17.0264H19.436V18.0264H20.436V15.0264H19.436V16.0264H18.436ZM20.436 20.0264V19.0264H19.436V20.0264H20.436ZM20.436 12.0264V11.0264H19.436V12.0264H20.436Z",
                        fill: "#1F1F1D"
                    })
                })
            }),
            " ",
            "Plantee app"
        ]
    }));
}

;// CONCATENATED MODULE: ./app/components/Footer.tsx






function Footer() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        className: (Footer_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* Container */.W, {
            view: "wide",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Footer_module_default()).inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Footer_module_default()).left,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                className: (Footer_module_default()).logo,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo_svg/* Logo */.T, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                className: (Footer_module_default()).copy,
                                children: "\xa9 ".concat(new Date().getFullYear(), " Plantee Innovations s.r.o.")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Footer_module_default()).right,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanteeAppLink, {})
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 924:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ Logo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function Logo() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "115",
        height: "33",
        viewBox: "0 0 115 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M49.7207 19.4151C48.5801 18.3187 47.1046 17.7024 45.2938 17.7024C43.4829 17.7024 41.9407 18.2506 40.8674 19.4151C39.7273 20.5103 39.1911 22.018 39.1911 23.8682V31.7462H42.2761V24.2107C42.2761 23.1144 42.5442 22.2242 43.0808 21.6073C43.617 20.9903 44.355 20.6484 45.2938 20.6484C46.2325 20.6484 46.9706 20.9909 47.5073 21.5385C48.0434 22.1555 48.312 23.0462 48.312 24.1426V31.6786H51.397V23.8C51.397 22.018 50.8603 20.5103 49.7207 19.4151ZM58.6893 28.4582C58.2867 28.0463 58.0853 27.4993 58.0853 26.7455V20.9228H61.9083V18.1824H58.0186V15.0995H54.9331V18.1824H52.5861V20.9228H54.9331V26.9511C54.9331 28.4588 55.4025 29.6921 56.2084 30.5822C57.0798 31.4724 58.2867 31.8837 59.7627 31.8837H61.9756V29.0058H60.2994C59.6281 29.0745 59.0926 28.8689 58.6893 28.4582ZM73.5421 18.8675C72.4687 18.2506 71.2613 17.908 69.9872 17.908C68.713 17.908 67.5051 18.2506 66.4995 18.8675C65.4267 19.4838 64.622 20.374 64.018 21.471C63.414 22.5668 63.1465 23.8 63.1465 25.1702C63.1465 27.2249 63.8172 28.9382 65.1581 30.3084C66.4996 31.6786 68.109 32.3631 70.0545 32.3631C71.5299 32.3631 72.8714 31.9518 74.0115 31.1298C75.0849 30.3766 75.8896 29.3484 76.4263 28.0463L76.4925 27.91H73.1395V27.9782C72.8708 28.39 72.4687 28.732 71.9993 28.9376C71.3953 29.2802 70.7925 29.4171 70.0545 29.4171C69.0478 29.4171 68.1763 29.1427 67.5051 28.5264C66.9016 27.9782 66.499 27.2249 66.2988 26.3342H76.7611V26.1285C76.8284 25.7854 76.8284 25.4434 76.8284 25.2378C76.8284 23.9364 76.5592 22.7031 75.9569 21.6073C75.4197 20.374 74.6149 19.552 73.5421 18.8675ZM66.2988 23.5938C66.4996 22.7718 66.9695 22.0861 67.5718 21.6073C68.2431 21.0591 69.0478 20.7859 69.9866 20.7859C70.9254 20.7859 71.7307 21.0591 72.4008 21.6073C73.0048 22.0861 73.4069 22.7718 73.6744 23.5938H66.2988ZM91.1804 21.471C90.6437 20.374 89.7722 19.4838 88.7667 18.8675C87.6928 18.2506 86.486 17.908 85.2113 17.908C83.9377 17.908 82.7303 18.2506 81.7248 18.8675C80.6508 19.4838 79.8466 20.374 79.2426 21.471C78.6386 22.5668 78.3706 23.8 78.3706 25.1702C78.3706 27.2249 79.0413 28.9382 80.3828 30.3084C81.7242 31.6786 83.3343 32.3631 85.2791 32.3631C86.754 32.3631 88.0955 31.9518 89.2361 31.1298C90.3095 30.3766 91.1143 29.3484 91.6509 28.0463L91.7177 27.91H88.3641V27.9782C88.0949 28.39 87.6928 28.732 87.224 28.9376C86.62 29.2802 86.0166 29.4171 85.2791 29.4171C84.273 29.4171 83.401 29.1427 82.7303 28.5264C82.1257 27.9782 81.7242 27.2249 81.5229 26.3342H92.053V26.1285C92.1198 25.7854 92.1198 25.4434 92.1198 25.2378C92.053 23.8 91.7844 22.5668 91.1804 21.471ZM81.5229 23.5938C81.7248 22.7718 82.1936 22.0861 82.797 21.6073C83.4677 21.0591 84.273 20.7859 85.2107 20.7859C86.15 20.7859 86.9553 21.0591 87.6255 21.6073C88.2295 22.0861 88.6321 22.7718 88.8996 23.5938H81.5229ZM20.1264 31.7485H16.896V12.6865H20.1264V31.7485ZM36.6868 31.7485H33.7273V29.1963H33.6737C32.9134 30.9714 31.1762 32.1085 28.9222 32.1085C27.1575 32.1085 25.6102 31.4706 24.2802 30.2228C22.9496 28.947 22.2983 27.1725 22.2983 24.8987C22.2983 22.819 22.977 21.0999 24.307 19.7408C25.6644 18.3822 27.4016 17.689 29.5193 17.689C31.6638 17.689 33.3742 18.3548 34.7048 19.714C36.0349 21.0439 36.6868 22.819 36.6868 25.0094V31.7485ZM29.5193 29.0303C30.6868 29.0303 31.6364 28.6423 32.3693 27.8937C33.1028 27.1177 33.4552 26.1186 33.4552 24.8987C33.4552 23.6783 33.1022 22.6798 32.3693 21.9318C31.6364 21.1552 30.6862 20.7672 29.5193 20.7672C28.3518 20.7672 27.3748 21.1552 26.6414 21.9318C25.9085 22.6798 25.5555 23.6783 25.5555 24.8987C25.5555 26.1186 25.9085 27.1177 26.6414 27.8937C27.3748 28.6423 28.3518 29.0303 29.5193 29.0303ZM14.4304 16.6159C13.88 15.4216 12.9829 14.6486 11.8468 13.9227C10.7757 13.2388 9.47474 12.8933 8.09908 12.8933C6.72342 12.8933 5.48579 13.2446 4.31659 13.8767C3.21584 14.5088 2.42592 15.4648 1.8071 16.5885C1.19227 17.7053 0.745126 18.9188 0.740564 20.314H0.738281V31.7403H4.03998V27.7912L8.09908 27.7877C9.47531 27.7877 10.7129 27.437 11.8821 26.8037C12.9823 26.1722 13.7837 25.2477 14.403 24.1239C15.0219 22.9996 15.4582 21.7465 15.4582 20.3414C15.4582 18.9357 15.0492 17.7391 14.4304 16.6159ZM11.1247 23.3625C10.369 24.1344 9.33672 24.5568 8.16752 24.5568L4.04283 24.5545C4.04283 24.5545 4.04112 20.8552 4.04112 20.2703C4.04112 19.0061 4.45347 18.0222 5.21031 17.1792C5.96715 16.4068 6.9989 15.985 8.16809 15.985C9.33729 15.985 10.369 16.4068 11.1253 17.1792C11.8827 17.9523 12.4069 18.9962 12.4069 20.2604C12.4063 21.5251 11.8821 22.5184 11.1247 23.3625Z",
                fill: "#1D1D1B"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M111.442 16.653C110.891 15.4587 109.995 14.6857 108.858 13.9598C107.788 13.2759 106.487 12.9304 105.111 12.9304C103.736 12.9304 102.497 13.2817 101.328 13.9138C101.234 13.968 101.154 14.0379 101.064 14.0967V9.865H101.061C101.057 8.46976 100.61 7.25571 99.9948 6.13952C99.376 5.01576 98.5861 4.05978 97.4853 3.4277C96.3161 2.79562 95.0779 2.44434 93.7028 2.44434C92.3266 2.44434 91.0257 2.78979 89.9551 3.47372C88.819 4.19959 87.9225 4.97265 87.3721 6.1669C86.7527 7.29008 86.3438 8.48666 86.3438 9.8918C86.3438 11.2969 86.7795 12.55 87.3989 13.6744C88.0183 14.7987 88.8196 15.7232 89.9198 16.3541C91.0895 16.9874 92.3272 17.3381 93.7034 17.3381L97.7408 17.3194L97.7505 31.7769H101.052V27.8277L105.111 27.8242C106.488 27.8242 107.725 27.4735 108.895 26.8402C109.995 26.2087 110.796 25.2842 111.416 24.1605C112.035 23.0361 112.471 21.783 112.471 20.3779C112.47 18.9728 112.061 17.7762 111.442 16.653ZM97.7585 14.1049L93.6338 14.1072C92.4646 14.1072 91.4329 13.6849 90.6766 12.913C89.9192 12.0694 89.3956 11.0761 89.3956 9.81082C89.3956 8.54666 89.9192 7.50271 90.6766 6.72965C91.4323 5.95718 92.4646 5.5354 93.6338 5.5354C94.803 5.5354 95.8348 5.95718 96.5922 6.72965C97.3485 7.57262 97.7608 8.55657 97.7608 9.82072C97.7602 10.4056 97.7585 14.1049 97.7585 14.1049ZM108.136 23.3991C107.381 24.1709 106.348 24.5933 105.179 24.5933L101.055 24.591L101.064 20.0528C101.117 18.911 101.518 18.001 102.221 17.2158C102.978 16.4433 104.011 16.0215 105.18 16.0215C106.349 16.0215 107.381 16.4433 108.137 17.2158C108.894 17.9888 109.418 19.0328 109.418 20.2969C109.417 21.5622 108.894 22.5555 108.136 23.3991Z",
                fill: "url(#paint0_linear_1101_3715)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                    id: "paint0_linear_1101_3715",
                    x1: "87.0437",
                    y1: "6.07322",
                    x2: "108.742",
                    y2: "27.3162",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "0.0054",
                            stopColor: "#63ED45"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                            offset: "1",
                            stopColor: "#15EFCE"
                        })
                    ]
                })
            })
        ]
    });
}


/***/ }),

/***/ 1799:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "J": function() { return /* binding */ Nav; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./app/hooks/useAuth.ts
var useAuth = __webpack_require__(1108);
// EXTERNAL MODULE: ./app/hooks/useMediaQuery.ts
var useMediaQuery = __webpack_require__(6220);
// EXTERNAL MODULE: ./app/hooks/usePlanteeUser.ts
var usePlanteeUser = __webpack_require__(4481);
// EXTERNAL MODULE: ./app/styles/Nav.module.sass
var Nav_module = __webpack_require__(8776);
var Nav_module_default = /*#__PURE__*/__webpack_require__.n(Nav_module);
// EXTERNAL MODULE: ./app/components/Logo.svg.tsx
var Logo_svg = __webpack_require__(924);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./app/components/NavUser.module.sass
var NavUser_module = __webpack_require__(1679);
var NavUser_module_default = /*#__PURE__*/__webpack_require__.n(NavUser_module);
;// CONCATENATED MODULE: ./app/components/NavUser.tsx
/* eslint-disable @next/next/no-html-link-for-pages */ 







function NavUser(props) {
    var _props_user, _props_user1, _props_user_avatar, _props_user2, _props_user3, _props_user4, _props_user5, _props_user_avatar1, _props_user6;
    const plantee = (0,usePlanteeUser/* usePlanteeUser */.e)();
    const [menuOpen, setMenuOpen] = react.useState(false);
    const router = (0,next_router.useRouter)();
    const locale = router.locale;
    var _props_user_avatar_alt, _ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (NavUser_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (NavUser_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: (0,clsx_m/* default */.Z)((NavUser_module_default()).button, menuOpen && (NavUser_module_default()).menuOpen),
                    onClick: ()=>{
                        setMenuOpen((old)=>!old);
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (NavUser_module_default()).burger,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (NavUser_module_default()).image,
                            children: ((_props_user = props.user) === null || _props_user === void 0 ? void 0 : _props_user.avatar) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: (_props_user1 = props.user) === null || _props_user1 === void 0 ? void 0 : (_props_user_avatar = _props_user1.avatar) === null || _props_user_avatar === void 0 ? void 0 : _props_user_avatar.url,
                                layout: "fill",
                                objectFit: "cover",
                                alt: (_ref = (_props_user_avatar_alt = (_props_user2 = props.user) === null || _props_user2 === void 0 ? void 0 : _props_user2.avatar.alt) !== null && _props_user_avatar_alt !== void 0 ? _props_user_avatar_alt : (_props_user3 = props.user) === null || _props_user3 === void 0 ? void 0 : _props_user3.avatar.description) !== null && _ref !== void 0 ? _ref : "",
                                placeholder: "blur",
                                blurDataURL: (_props_user4 = props.user) === null || _props_user4 === void 0 ? void 0 : _props_user4.avatar.url
                            }, String((_props_user5 = props.user) === null || _props_user5 === void 0 ? void 0 : (_props_user_avatar1 = _props_user5.avatar) === null || _props_user_avatar1 === void 0 ? void 0 : _props_user_avatar1.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                    className: (0,clsx_m/* default */.Z)((NavUser_module_default()).menu, menuOpen && (NavUser_module_default()).active),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                href: "/create",
                                children: locale === "cs" ? "Vytvořit nov\xfd pěstebn\xed profil" : "Create a new plant profile"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/user/".concat((_props_user6 = props.user) === null || _props_user6 === void 0 ? void 0 : _props_user6.id),
                                children: locale === "cs" ? "Můj profil" : "My profile"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/user/edit",
                                children: locale === "cs" ? "Nastaven\xed profilu" : "Edit profile"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
                                action: "",
                                method: "POST",
                                onSubmit: (e)=>{
                                    e.preventDefault();
                                    plantee.auth.signOut.mutate();
                                    router.push("/");
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("fieldset", {
                                    disabled: plantee.auth.signOut.isLoading,
                                    style: {
                                        opacity: plantee.auth.signOut.isLoading ? 0.5 : 1
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                        type: "submit",
                                        children: locale === "cs" ? "Odhl\xe1sit se" : "Log out"
                                    })
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./app/components/Search.tsx + 2 modules
var Search = __webpack_require__(9741);
;// CONCATENATED MODULE: ./app/components/Nav.tsx










function PrimaryNavItems() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Nav_module_default()).primaryNavItems
    });
}
function Nav() {
    var _plantee_auth_me_data;
    const locale = (0,next_router.useRouter)().locale;
    const plantee = (0,usePlanteeUser/* usePlanteeUser */.e)();
    const signedIn = (0,useAuth/* useIsSignedIn */.AN)();
    const signedOut = (0,useAuth/* useIsSignedOut */.tW)();
    const user = (_plantee_auth_me_data = plantee.auth.me.data) === null || _plantee_auth_me_data === void 0 ? void 0 : _plantee_auth_me_data.user;
    const isMobile = (0,useMediaQuery/* default */.Z)("(max-width: 900px)");
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        className: (Nav_module_default()).wrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (Nav_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                    href: "/",
                    className: (Nav_module_default()).logo,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Logo_svg/* Logo */.T, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "base"
                        })
                    ]
                }),
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (Nav_module_default()).primaryNavItems,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PrimaryNavItems, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Search/* Search */.o, {})
                    ]
                }),
                !!(signedIn && user) && /*#__PURE__*/ (0,jsx_runtime.jsx)(NavUser, {
                    user: user
                }),
                signedOut && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Nav_module_default()).user,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/user/edit",
                        children: locale === "cs" ? "Přihl\xe1sit se" : "Log in"
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 9741:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "o": function() { return /* binding */ Search; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(7848);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(6010);
// EXTERNAL MODULE: ./node_modules/next/legacy/image.js
var legacy_image = __webpack_require__(9755);
var image_default = /*#__PURE__*/__webpack_require__.n(legacy_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./app/utils/SearchContext.tsx
var SearchContext = __webpack_require__(198);
// EXTERNAL MODULE: ./node_modules/next/dist/client/router.js
var client_router = __webpack_require__(880);
;// CONCATENATED MODULE: ./app/utils/usePageLoadingState.ts


function usePageLoadingState() {
    const { asPath , events  } = (0,client_router.useRouter)();
    const [loading, setLoading] = react.useState(false);
    const [duration, setDuration] = react.useState(0);
    react.useEffect(()=>{
        const handleStart = ()=>{
            setLoading(true);
        };
        const handleComplete = ()=>{
            setLoading(false);
        };
        events.on("routeChangeStart", handleStart);
        events.on("routeChangeComplete", handleComplete);
        events.on("routeChangeError", handleComplete);
        return ()=>{
            events.off("routeChangeStart", handleStart);
            events.off("routeChangeComplete", handleComplete);
            events.off("routeChangeError", handleComplete);
        };
    }, [
        asPath,
        events
    ]);
    react.useEffect(()=>{
        if (loading) {
            const start = new Date().getTime();
            const interval = setInterval(()=>{
                setDuration(new Date().getTime() - start);
            }, 100);
            return ()=>clearInterval(interval);
        } else {
            setDuration(0);
        }
    }, [
        loading
    ]);
    return [
        loading,
        duration
    ];
}

// EXTERNAL MODULE: ./app/components/Search.module.sass
var Search_module = __webpack_require__(6745);
var Search_module_default = /*#__PURE__*/__webpack_require__.n(Search_module);
;// CONCATENATED MODULE: ./app/components/SearchIcon.svg.tsx

function SearchIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        width: "36",
        height: "36",
        viewBox: "0 0 36 36",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("circle", {
                cx: "16.3456",
                cy: "16.331",
                r: "8.09171",
                stroke: "#5A5A5A",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.4834 28.4687L24.4375 24.4229",
                stroke: "#5A5A5A",
                strokeWidth: "2",
                strokeLinecap: "square"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./app/components/Search.tsx











function Search(props) {
    const search = (0,SearchContext/* useSearch */.Rx)();
    const locale = (0,router.useRouter)().locale;
    const searchInput = react.useRef(null);
    const [loading] = usePageLoadingState();
    react.useEffect(()=>{
        if (loading) {
            search.setQuery("");
        }
    }, [
        loading,
        search
    ]);
    const result = (0,useQuery/* useQuery */.a)([
        "search",
        search.query
    ], async (context)=>{
        const q = context.queryKey[1];
        if (q) {
            const result = await search.search(q);
            return {
                plantProfiles: result.plantProfiles.listPlantProfileLocale
            };
        }
        return null;
    }, {
        keepPreviousData: true
    });
    const results = result.data;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)((Search_module_default()).wrapper, props.isMobile && (Search_module_default()).viewMobile),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,clsx_m/* default */.Z)((Search_module_default()).container),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)((Search_module_default()).search, props.isMobile && (Search_module_default()).viewMobile),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                            type: "search",
                            placeholder: locale === "cs" ? "Hledat" : "Search",
                            ref: searchInput,
                            onChange: async (e)=>{
                                const query = e.target.value;
                                search.setQuery(query);
                            }
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            className: (Search_module_default()).searchButton,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchIcon, {})
                        })
                    ]
                }),
                (results === null || results === void 0 ? void 0 : results.plantProfiles) && (results === null || results === void 0 ? void 0 : results.plantProfiles.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    className: (Search_module_default()).results,
                    children: results === null || results === void 0 ? void 0 : results.plantProfiles.map((item)=>{
                        var _item_root, _item_root_activeInPlantProfile, _item_root_activeInPlantProfile_author, _item_root1, _item_root_activeInPlantProfile1, _item_root2, _item_root3, _item_root_thumbnail, _item_root4;
                        var _item_root_thumbnail_alt, _ref;
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                href: "/profile/".concat((_item_root = item.root) === null || _item_root === void 0 ? void 0 : (_item_root_activeInPlantProfile = _item_root.activeInPlantProfile) === null || _item_root_activeInPlantProfile === void 0 ? void 0 : (_item_root_activeInPlantProfile_author = _item_root_activeInPlantProfile.author) === null || _item_root_activeInPlantProfile_author === void 0 ? void 0 : _item_root_activeInPlantProfile_author.id, "/").concat((_item_root1 = item.root) === null || _item_root1 === void 0 ? void 0 : (_item_root_activeInPlantProfile1 = _item_root1.activeInPlantProfile) === null || _item_root_activeInPlantProfile1 === void 0 ? void 0 : _item_root_activeInPlantProfile1.id),
                                className: (Search_module_default()).searchItem,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (Search_module_default()).searchItemImage,
                                        children: ((_item_root2 = item.root) === null || _item_root2 === void 0 ? void 0 : _item_root2.thumbnail) && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: (_item_root3 = item.root) === null || _item_root3 === void 0 ? void 0 : (_item_root_thumbnail = _item_root3.thumbnail) === null || _item_root_thumbnail === void 0 ? void 0 : _item_root_thumbnail.url,
                                            layout: "fill",
                                            objectFit: "cover",
                                            alt: (_ref = (_item_root_thumbnail_alt = item.root.thumbnail.alt) !== null && _item_root_thumbnail_alt !== void 0 ? _item_root_thumbnail_alt : item.root.thumbnail.description) !== null && _ref !== void 0 ? _ref : "",
                                            placeholder: "blur",
                                            blurDataURL: item.root.thumbnail.url
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        children: item.name
                                    })
                                ]
                            })
                        }, String((_item_root4 = item.root) === null || _item_root4 === void 0 ? void 0 : _item_root4.id));
                    })
                })
            ]
        })
    });
}


/***/ }),

/***/ 1108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AN": function() { return /* binding */ useIsSignedIn; },
/* harmony export */   "aC": function() { return /* binding */ useAuth; },
/* harmony export */   "tW": function() { return /* binding */ useIsSignedOut; }
/* harmony export */ });
/* unused harmony export useAuthStatus */
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5945);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7848);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8228);
/* harmony import */ var _libs_next_api_jsonApiHandler__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3241);


const api = (0,_libs_next_api_jsonApiHandler__WEBPACK_IMPORTED_MODULE_0__/* .createFetcher */ .gt)("/api/auth/[handler]");
function useAuth() {
    const queryClient = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useQueryClient */ .NL)();
    const me = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .useQuery */ .a)([
        "auth",
        "me"
    ], async ()=>{
        return api("me", {});
    });
    const signIn = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (credentials)=>{
        const response = await api("signIn", credentials);
        if (response.ok === false) {
            throw new Error(response.errorMessage);
        }
    }, {
        onSettled () {
            queryClient.invalidateQueries([
                "auth"
            ]);
        }
    });
    const signOut = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async ()=>{
        return api("signOut", {
            _req: {
                method: "POST"
            }
        }).then(()=>{
            queryClient.invalidateQueries([
                "auth"
            ]);
        });
    });
    const signUp = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (credentials)=>{
        return api("signUp", credentials).then(()=>{
            queryClient.invalidateQueries([
                "auth"
            ]);
        });
    });
    const likeProfile = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (data)=>{
        return api("likeProfile", data).then((data)=>{
            queryClient.invalidateQueries([
                "auth"
            ]);
            return data;
        });
    });
    const removeProfile = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (data)=>{
        return api("removeProfile", data).then((data)=>{
            queryClient.invalidateQueries([
                "auth"
            ]);
            return data;
        });
    });
    const setAvatar = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (data)=>{
        return api("setAvatar", data).then(async (res)=>{
            var _res_uploadUrl;
            if ((_res_uploadUrl = res.uploadUrl) === null || _res_uploadUrl === void 0 ? void 0 : _res_uploadUrl.url) {
                const s3upload = await fetch(res.uploadUrl.url, {
                    method: res.uploadUrl.method,
                    body: data.image,
                    headers: res.uploadUrl.headers.reduce((headers, h)=>({
                            ...headers,
                            [h.key]: h.value
                        }), {})
                });
                console.log(s3upload);
            }
            queryClient.invalidateQueries([
                "auth"
            ]);
        });
    });
    const createPlantProfile = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (data)=>{
        var _data_plantProfile_thumbnail;
        return api("createProfile", {
            plantProfile: {
                ...data.plantProfile,
                thumbnail: undefined,
                images: []
            },
            mimeType: (_data_plantProfile_thumbnail = data.plantProfile.thumbnail) === null || _data_plantProfile_thumbnail === void 0 ? void 0 : _data_plantProfile_thumbnail.type,
            imagesMimeTypes: data.plantProfile.images.map((image)=>{
                var _data_plantProfile_thumbnail;
                return {
                    mimeType: image.type,
                    isThumbnail: image.name === ((_data_plantProfile_thumbnail = data.plantProfile.thumbnail) === null || _data_plantProfile_thumbnail === void 0 ? void 0 : _data_plantProfile_thumbnail.name)
                };
            })
        }).then(async (res)=>{
            var _res_imageMutation;
            if (res.mutation.createPlantProfile.ok) {
                console.log(res.mutation.createPlantProfile.ok);
            }
            if (((_res_imageMutation = res.imageMutation) === null || _res_imageMutation === void 0 ? void 0 : _res_imageMutation.generateUploadUrl.url) && data.plantProfile.thumbnail) {
                var _res_imageMutation1, _res_imageMutation2, _res_imageMutation3;
                const s3upload = await fetch((_res_imageMutation1 = res.imageMutation) === null || _res_imageMutation1 === void 0 ? void 0 : _res_imageMutation1.generateUploadUrl.url, {
                    method: (_res_imageMutation2 = res.imageMutation) === null || _res_imageMutation2 === void 0 ? void 0 : _res_imageMutation2.generateUploadUrl.method,
                    body: data.plantProfile.thumbnail,
                    headers: (_res_imageMutation3 = res.imageMutation) === null || _res_imageMutation3 === void 0 ? void 0 : _res_imageMutation3.generateUploadUrl.headers.reduce((headers, h)=>({
                            ...headers,
                            [h.key]: h.value
                        }), {})
                });
                console.log(s3upload);
            }
            //upload gallery images
            console.log(res.galleryImagesMutations);
            console.log(data.plantProfile.images);
            const galleryUploads = await Promise.allSettled(res.galleryImagesMutations.map(async (galleryImageMutation, index)=>{
                if (galleryImageMutation && galleryImageMutation.generateUploadUrl.url && data.plantProfile.images[index]) {
                    await fetch(galleryImageMutation.generateUploadUrl.url, {
                        method: galleryImageMutation.generateUploadUrl.method,
                        body: data.plantProfile.images[index],
                        headers: galleryImageMutation.generateUploadUrl.headers.reduce((headers, h)=>({
                                ...headers,
                                [h.key]: h.value
                            }), {})
                    });
                }
            }));
            //Check gallery uploads
            console.log(galleryUploads);
            console.log(res.mutation.createPlantProfile);
            queryClient.invalidateQueries([
                "auth"
            ]);
            return res.mutation.createPlantProfile;
        });
    });
    const updatePlantProfile = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (data)=>{
        var _data_plantProfile_thumbnail;
        return api("updateProfile", {
            profileId: data.profileId,
            plantProfile: {
                ...data.plantProfile,
                thumbnail: undefined,
                images: []
            },
            mimeType: (_data_plantProfile_thumbnail = data.plantProfile.thumbnail) === null || _data_plantProfile_thumbnail === void 0 ? void 0 : _data_plantProfile_thumbnail.type,
            imagesMimeTypes: data.plantProfile.images.map((image)=>{
                var _data_plantProfile_thumbnail;
                return {
                    mimeType: image.type,
                    isThumbnail: image.name === ((_data_plantProfile_thumbnail = data.plantProfile.thumbnail) === null || _data_plantProfile_thumbnail === void 0 ? void 0 : _data_plantProfile_thumbnail.name)
                };
            })
        }).then(async (res)=>{
            var _res_imageMutation;
            if (res.mutation.updatePlantProfile.ok) {
                console.log(res.mutation.updatePlantProfile.ok);
            }
            if (((_res_imageMutation = res.imageMutation) === null || _res_imageMutation === void 0 ? void 0 : _res_imageMutation.generateUploadUrl.url) && data.plantProfile.thumbnail) {
                var _res_imageMutation1, _res_imageMutation2, _res_imageMutation3;
                const s3upload = await fetch((_res_imageMutation1 = res.imageMutation) === null || _res_imageMutation1 === void 0 ? void 0 : _res_imageMutation1.generateUploadUrl.url, {
                    method: (_res_imageMutation2 = res.imageMutation) === null || _res_imageMutation2 === void 0 ? void 0 : _res_imageMutation2.generateUploadUrl.method,
                    body: data.plantProfile.thumbnail,
                    headers: (_res_imageMutation3 = res.imageMutation) === null || _res_imageMutation3 === void 0 ? void 0 : _res_imageMutation3.generateUploadUrl.headers.reduce((headers, h)=>({
                            ...headers,
                            [h.key]: h.value
                        }), {})
                });
                console.log(s3upload);
            }
            //upload gallery images
            console.log(res.galleryImagesMutations);
            console.log(data.plantProfile.images);
            const galleryUploads = await Promise.allSettled(res.galleryImagesMutations.map(async (galleryImageMutation, index)=>{
                if (galleryImageMutation && galleryImageMutation.generateUploadUrl.url && data.plantProfile.images[index]) {
                    await fetch(galleryImageMutation.generateUploadUrl.url, {
                        method: galleryImageMutation.generateUploadUrl.method,
                        body: data.plantProfile.images[index],
                        headers: galleryImageMutation.generateUploadUrl.headers.reduce((headers, h)=>({
                                ...headers,
                                [h.key]: h.value
                            }), {})
                    });
                }
            }));
            //Check gallery uploads
            console.log(galleryUploads);
            console.log(res.mutation.updatePlantProfile);
            queryClient.invalidateQueries([
                "auth"
            ]);
            return res.mutation.updatePlantProfile;
        });
    });
    const addComment = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (data)=>{
        return api("addComment", data).then(async (res)=>{
            var _res_imageMutation;
            if (res.mutation.createDiscussionPost.ok) {
                console.log(res.mutation.createDiscussionPost.ok);
            }
            if ((_res_imageMutation = res.imageMutation) === null || _res_imageMutation === void 0 ? void 0 : _res_imageMutation.generateUploadUrl.url) {
                var _res_imageMutation1, _res_imageMutation2, _res_imageMutation3;
                const s3upload = await fetch((_res_imageMutation1 = res.imageMutation) === null || _res_imageMutation1 === void 0 ? void 0 : _res_imageMutation1.generateUploadUrl.url, {
                    method: (_res_imageMutation2 = res.imageMutation) === null || _res_imageMutation2 === void 0 ? void 0 : _res_imageMutation2.generateUploadUrl.method,
                    body: data.image,
                    headers: (_res_imageMutation3 = res.imageMutation) === null || _res_imageMutation3 === void 0 ? void 0 : _res_imageMutation3.generateUploadUrl.headers.reduce((headers, h)=>({
                            ...headers,
                            [h.key]: h.value
                        }), {})
                });
                console.log(s3upload);
            }
            console.log(res);
            queryClient.invalidateQueries([
                "auth"
            ]);
            return res;
        });
    });
    const setUserInfo = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (data)=>{
        return api("setUserInfo", data).then(async (res)=>{
            if (res.updateUser.ok) {
                console.log(res.updateUser.ok);
            }
            console.log(res.updateUser);
            console.log("fail");
            queryClient.invalidateQueries([
                "auth"
            ]);
        });
    });
    const changePassword = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (data)=>{
        return api("changePassword", data).then(async (res)=>{
            if ((res === null || res === void 0 ? void 0 : res.statusCode) === "200") {
                return {
                    ok: true
                };
            } else {
                throw new Error("Something went wrong");
            }
        });
    });
    const passwordReset = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_3__/* .useMutation */ .D)(async (data)=>{
        return api("passwordReset", data).then(async (res)=>{
            if ((res === null || res === void 0 ? void 0 : res.statusCode) === "200") {
                return {
                    ok: true,
                    statusCode: res.statusCode
                };
            } else {
                return res;
            //throw new Error(res.errorMessage)
            }
        });
    });
    return {
        me,
        signIn,
        signUp,
        signOut,
        setAvatar,
        likeProfile,
        createPlantProfile,
        setUserInfo,
        changePassword,
        addComment,
        removeProfile,
        passwordReset,
        updatePlantProfile
    };
}
function useAuthStatus() {
    var _auth_me_data;
    const auth = useAuth();
    if (auth.me.isLoading) {
        return "loading";
    }
    if (auth.me.isError) {
        return "error";
    }
    if ((_auth_me_data = auth.me.data) === null || _auth_me_data === void 0 ? void 0 : _auth_me_data.status) {
        return auth.me.data.status;
    }
    return "unknown";
}
function useIsSignedIn() {
    return useAuthStatus() === "signedIn";
}
function useIsSignedOut() {
    return useAuthStatus() === "signedOut";
}


/***/ }),

/***/ 6220:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

const useMediaQuery = (query)=>{
    const [matches, setMatches] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const media = window.matchMedia(query);
        if (media.matches !== matches) {
            setMatches(media.matches);
        }
        const listener = ()=>setMatches(media.matches);
        window.addEventListener("resize", listener);
        return ()=>window.removeEventListener("resize", listener);
    }, [
        matches,
        query
    ]);
    return matches;
};
/* harmony default export */ __webpack_exports__["Z"] = (useMediaQuery);


/***/ }),

/***/ 4481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ usePlanteeUser; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8228);
/* harmony import */ var _useAuth__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1108);


function usePlanteeUser() {
    const auth = (0,_useAuth__WEBPACK_IMPORTED_MODULE_0__/* .useAuth */ .aC)();
    const changeNick = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .useMutation */ .D)(async (patch)=>{
        alert("Changed nick to ".concat(patch.nick));
    });
    return {
        auth,
        changeNick
    };
}


/***/ }),

/***/ 5450:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Button_wrapper__9z8IE","is_fill_empty":"Button_is_fill_empty__FC5Bu","is_border":"Button_is_border__G0POt","is_fill_green100":"Button_is_fill_green100__IpJ4T","is_fill_green600":"Button_is_fill_green600__XBQwz","is_fill_greenButton":"Button_is_fill_greenButton__JwLAV","is_fill_grey100":"Button_is_fill_grey100__xN2mF","is_fill_groundBlack":"Button_is_fill_groundBlack__8XU3d","is_fill_red600":"Button_is_fill_red600__vj9rc","is_upperCase":"Button_is_upperCase__HccFY","is_fontWeight_400":"Button_is_fontWeight_400__Lsany","is_fontSize_small":"Button_is_fontSize_small__Z8Vrf","is_size_2":"Button_is_size_2__BlULB","is_size_3":"Button_is_size_3__UufKz","content":"Button_content__MuEzf","is_icon_end":"Button_is_icon_end__v7Gk6","icon":"Button_icon__JIgBG"};

/***/ }),

/***/ 8539:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Container_wrapper__IWY85","wide":"Container_wide__1KznT","slim":"Container_slim___cSAk"};

/***/ }),

/***/ 6679:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__pmue9","inner":"Footer_inner__SikFw","right":"Footer_right__1W37T","copy":"Footer_copy__eLgKf"};

/***/ }),

/***/ 1679:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"NavUser_wrapper__L9hc4","inner":"NavUser_inner__8FLZo","button":"NavUser_button__Te7nq","menuOpen":"NavUser_menuOpen__EH3uy","burger":"NavUser_burger___u9ZE","image":"NavUser_image__dZ2XF","menu":"NavUser_menu__H1oXh","active":"NavUser_active__BNLH2"};

/***/ }),

/***/ 6729:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PlanteeAppLink_wrapper__mOyqr","icon":"PlanteeAppLink_icon__fJBOu"};

/***/ }),

/***/ 6745:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"Search_search__0QIka","searchButton":"Search_searchButton__MWtia","wrapper":"Search_wrapper__RCJFQ","viewMobile":"Search_viewMobile__CtQ_4","container":"Search_container__2Ub9o","results":"Search_results__BB7Wg","searchItem":"Search_searchItem__pHC4j","searchItemImage":"Search_searchItemImage__qnjNg"};

/***/ }),

/***/ 8776:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Nav_wrapper__owAh0","inner":"Nav_inner__rdQf1","search":"Nav_search__RleCU","logo":"Nav_logo__xQCL5","searchButton":"Nav_searchButton__MmtNn","user":"Nav_user___rszS","primaryNavItems":"Nav_primaryNavItems__wmD3m"};

/***/ })

}]);